module.exports = __webpack_public_path__ + "img/logo2.f9acb3b0.png";